import { AxiosResponse } from "axios";
import { build, omit } from "search-params";

import {
	GeneratePropertyStatmentReqParams,
	GenerateAllStatmentsReqParams,
	GetStatmentsReqParams,
	GetStatementDownloadLinkReqParams,
	SendPropertyStatmentReqParams,
} from "models/statements";

import $http from "./instance";

class StatementsClient {
	public static async getStatements(
		params: GetStatmentsReqParams
	): Promise<AxiosResponse> {
		const { propertyIds, month, year, active } = params;

		let query = build({
			month,
			year,
			active,
			propertyIds,
		});

		if (!month) {
			query = omit(query, ["month"]).querystring;
		}
		if (!year) {
			query = omit(query, ["year"]).querystring;
		}

		return $http.get(`/reports/statement?${query}`);
	}

	public static async generateStatement(
		params: GeneratePropertyStatmentReqParams
	): Promise<AxiosResponse> {
		const { propertyId, month, year } = params;

		const query = build({
			month,
			year,
		});

		return $http.post(
			`/reports/statement/generate/property/${propertyId}?${query}`
		);
	}

	public static async generateAllStatements(
		params: GenerateAllStatmentsReqParams
	): Promise<AxiosResponse> {
		const { month, year } = params;

		const query = build({
			month,
			year,
		});

		return $http.post(`/reports/statement/generate?${query}`);
	}

	public static async sendStatement(
		params: SendPropertyStatmentReqParams
	): Promise<AxiosResponse> {
		const { propertyId, data, statementId } = params;

		return $http.post(
			`/reports/statement/property/${propertyId}/statement/${statementId}/send`,
			data
		);
	}

	public static async getStatementDownloadLink(
		params: GetStatementDownloadLinkReqParams
	): Promise<AxiosResponse> {
		const { propertyId, statementId } = params;

		return $http.get(
			`/reports/statement/property/${propertyId}/statement/${statementId}/download`
		);
	}
}

export default StatementsClient;
